import moment from 'moment';

import { textFieldFormat } from './TimePicker.constants';

/**
 * Converts the entered value in the input field to a date string for further use
 */
export const parseEnteredTextFieldValue = (value: string) => {
    if (!value) return;

    const parsedTime = moment(value, textFieldFormat, true);

    if (!parsedTime.isValid()) return;

    parsedTime.seconds(0).milliseconds(0);

    return parsedTime.toDate();
};

/**
 * Convert time to HH:mm format
 */
export const formatTextFieldValue = (value: Date | undefined) => {
    if (!value) return '';

    return moment(value).format(textFieldFormat);
};

/**
 * Converts a value to a Date object
 */
export const parseValueToDate = (value: Date | string | undefined | null): Date | undefined => {
    if (!value) return;

    if (value instanceof Date) return value;

    // If it's a string, try to parse it
    try {
        return new Date(value);
    } catch (_) {
        return;
    }
};
